global.propertySearch;
global.propertyMap;
global.mapPropertiesId = [];
global.sectorGSearch = [];

let themeGmapConfig = {
	minZoom: 1,
	maxZoom: 15,
	mapTypeControl: false,
	fullscreenControl: false,
	streetViewControl: false,
};

function stripHtml(html) {
	let tmp = document.createElement("DIV");
	tmp.innerHTML = html;
	return tmp.textContent || tmp.innerText || "";
}

// Les biens hors résultats restent sur la carte : bleu primary pour la recherche,
// noir (et plus transparent) pour le reste du parc.
const MARKER_COLOR_ACTIVE = "#547aab";
const MARKER_COLOR_INACTIVE = "#0e1a2b";

// null tant qu'aucune recherche n'a été lancée : tous les biens sont alors "actifs".
let activePropertyIds = null;
let mapMarkersInitialized = false;

function markerIconFor(isActive) {
	const baseIcon = propertyMap?.markerIcon ?? {};

	return {
		...baseIcon,
		fillColor: isActive ? MARKER_COLOR_ACTIVE : MARKER_COLOR_INACTIVE,
		fillOpacity: isActive ? 0.85 : 0.35,
	};
}

function applyMarkerState(marker) {
	const isActive = activePropertyIds === null || activePropertyIds.has(marker.id);

	marker.isActiveResult = isActive;
	marker.setIcon(markerIconFor(isActive));
	marker.setLabel({
		text: "1",
		color: isActive ? "#fff" : "rgba(255, 255, 255, 0.6)",
		fontSize: "1rem",
	});
	marker.setZIndex(isActive ? 2 : 1);
}

// Le premier lot de marqueurs cadre la carte sur l'ensemble des biens ; ensuite le cadrage
// suit les résultats de la recherche, pas la totalité des marqueurs conservés.
window.theme_gmap_before_create_markers = () => !mapMarkersInitialized;

window.theme_customize_gmap_marker = (map, marker) => applyMarkerState(marker);

window.theme_gmap_before_set_infowindow = () => ({
	propertyCard: $("#property-infowindow-model").clone(),
});

window.theme_osm_popup_model = () => $("#property-infowindow-model");

// initMap sert à la fois de callback à l'API Google et de fallback au window.load du plugin.
// Sans garde, la seconde exécution remplace la carte et perd les marqueurs déjà posés.
const remPluginInitMap = typeof window.initMap === "function" ? window.initMap : null;
window.initMap = () => {
	if (propertyMap?.googleMap) {
		return;
	}

	if (remPluginInitMap) {
		remPluginInitMap();
	} else {
		propertyMap = new PropertyMap();
	}
};

function closePropertyInfowindow() {
	if (propertyMap?.infoWindow) {
		propertyMap.infoWindow.close();
	} else if (propertyMap?.map?.closePopup) {
		propertyMap.map.closePopup();
	}
}

// OMS écarte par défaut les marqueurs empilés ("nudge") avec des décalages exprimés en pixels
// écran, mais il les recalcule 10 ms après zoom_changed, avant que la projection ne reflète le
// nouveau zoom : les décalages restent à l'échelle du zoom précédent et les pins finissent à
// plusieurs kilomètres de leur commune. Le spiderfier suffit à éventailler les lots au clic.
function installSpiderfier() {
	if (!propertyMap?.googleMap || typeof OverlappingMarkerSpiderfier === "undefined") {
		return;
	}

	propertyMap.enableOms = true;

	if (propertyMap.oms) {
		propertyMap.oms.nudgeStackedMarkers = false;
		propertyMap.oms.resetNudgedMarkers();
		return;
	}

	propertyMap.oms = new OverlappingMarkerSpiderfier(propertyMap.googleMap, {
		markersWontMove: true,
		markersWontHide: true,
		basicFormatEvents: true,
		nearbyDistance: 60,
		keepSpiderfied: true,
		nudgeStackedMarkers: false,
	});

	propertyMap.oms.addListener("unspiderfy", collapseSpiderfiedCluster);
}

// ~1 m : les lots d'une même promotion partagent le point exact de leur commune.
const STACKED_MARKERS_TOLERANCE = 1e-5;

function clusterMarkersAreStacked(cluster) {
	const positions = cluster.markers.map((marker) => marker.getPosition());
	const [reference] = positions;

	return positions.every((position) => Math.abs(position.lat() - reference.lat()) < STACKED_MARKERS_TOLERANCE && Math.abs(position.lng() - reference.lng()) < STACKED_MARKERS_TOLERANCE);
}

// Cluster dont on a masqué la pastille pour laisser voir l'éventail de ses marqueurs.
let spiderfiedCluster = null;

function spiderfyCluster(cluster) {
	collapseSpiderfiedCluster();

	cluster.marker.setVisible(false);
	cluster.markers.forEach((marker) => marker.setMap(propertyMap.googleMap));

	// spiderListener plutôt qu'un clic simulé : le plugin écoute "click" sur chaque marqueur
	// pour ouvrir son infowindow, on ne veut pas afficher un lot au hasard de la promotion.
	// Il commence par replier l'éventail précédent, d'où la mémorisation seulement ensuite.
	propertyMap.oms.spiderListener(cluster.markers[0]);
	spiderfiedCluster = cluster;
}

function collapseSpiderfiedCluster() {
	const cluster = spiderfiedCluster;
	spiderfiedCluster = null;

	// Un nouveau rendu du clusterer a pu remplacer la pastille entre-temps : elle n'est alors
	// plus sur la carte et c'est lui qui gère désormais l'affichage de ces marqueurs.
	if (!cluster || !cluster.marker.getMap()) {
		return;
	}

	cluster.markers.forEach((marker) => marker.setMap(null));
	cluster.marker.setVisible(true);
}

// Le renderer du plugin peint tous les clusters en primary et compte tous leurs marqueurs.
// On distingue ici les clusters qui contiennent au moins un résultat de la recherche.
function installClusterRenderer() {
	if (!propertyMap || typeof markerClusterer === "undefined") {
		return;
	}

	propertyMap.createClusters = function () {
		if (this.clusters) {
			this.clusters.setMap(null);
		}

		this.clusters = new markerClusterer.MarkerClusterer({
			map: this.googleMap,
			markers: this.oms !== null && this.enableOms === true ? this.oms.markers : this.markers,
			maxZoom: 13,
			renderer: {
				render: ({ count, position, markers }) => {
					const activeCount = (markers || []).filter((marker) => marker.isActiveResult).length;

					return new google.maps.Marker({
						label: {
							text: String(activeCount > 0 ? activeCount : count),
							color: "white",
							fontSize: "1rem",
						},
						position,
						zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
						icon: markerIconFor(activeCount > 0),
					});
				},
			},
			onClusterClick: (e, cluster) => {
				this.infoWindow.close();

				// Aucun zoom ne séparera des lots posés sur le même point : recadrer ne ferait que
				// reformer le cluster au zoom suivant. On éventaille directement.
				if (clusterMarkersAreStacked(cluster)) {
					spiderfyCluster(cluster);
					return;
				}

				// Les marqueurs ne sont pas révélés à la main : le clusterer les réaffiche lui-même
				// une fois le recadrage terminé, sinon ils réapparaissent puis se regroupent aussitôt.
				this.infoWindow.setOptions({ disableAutoPan: true });
				this.googleMap.fitBounds(cluster.bounds);
				setTimeout(() => this.infoWindow.setOptions({ disableAutoPan: false }), 1000);
			},
		});
	};
}

function fitMapToProperties(properties) {
	const bounds = new google.maps.LatLngBounds();
	let hasPoint = false;

	properties.forEach((property) => {
		if (property.geocoding.lat === "" || property.geocoding.lng === "") {
			return;
		}

		bounds.extend({
			lat: Number(property.geocoding.lat),
			lng: Number(property.geocoding.lng),
		});
		hasPoint = true;
	});

	if (hasPoint) {
		propertyMap.googleMap.fitBounds(bounds);
	}
}

// Les marqueurs ne sont jamais retirés : on ajoute ceux des biens encore inconnus et on
// recolore l'ensemble selon les résultats de la recherche.
function syncMapMarkers(properties) {
	if (!propertyMap?.googleMap || !Array.isArray(propertyMap.markers)) {
		return;
	}

	// Un éventail ouvert laisse ses marqueurs sur des positions factices : le clusterer les
	// regrouperait au mauvais endroit.
	propertyMap.oms?.unspiderfy();

	activePropertyIds = new Set(properties.map((property) => property.post_id));

	const knownIds = new Set(propertyMap.markers.map((marker) => marker.id));
	const unknownProperties = properties.filter((property) => !knownIds.has(property.post_id));

	propertyMap.markers.forEach((marker) => applyMarkerState(marker));

	mapMarkersInitialized = true;

	if (unknownProperties.length > 0) {
		// createMarkers applique l'état via theme_customize_gmap_marker et relance les clusters.
		propertyMap.createMarkers(unknownProperties);
	} else {
		propertyMap.createClusters();
	}

	fitMapToProperties(properties);
}

window.theme_gmap_before_set_infowindow_mustache_config = (mustacheConfig, property) => {
	property.post.post_content = property.post.post_content.replace(/<\/p>/g, " ");
	mustacheConfig.property.post.post_content = stripHtml(property.post.post_content);

	mustacheConfig.thumbnails = $.map(property.thumbnails.medium, (label, url) => ({
		label: label,
		url: url,
	}));
	return mustacheConfig;
};

window.theme_rem_search_mustache_config = (propertyCard, mustacheConfig, property) => {
	property.post.post_content = property.post.post_content.replace(/<\/p>/g, " ");
	property.post.post_content = stripHtml(property.post.post_content);

	return {
		property: property,
		thumbnails: {
			label: Object.entries(property.thumbnails.medium)[0][1],
			url: Object.entries(property.thumbnails.medium)[0][0],
		},
		// change prestige type because unusable by default in mustache
		prestige: property.prestige === "1",
		classic: property.prestige === "0",
		propertyListCard: true,
		hasAddress: property.address !== "",
		hasSurface: property.surface_utile > 0 || property.surface_habitable > 0,
		hasBedroom: property.nb_chambres > 0,
		hasPiece: property.nb_pieces > 0,
		hasBathroom: property.nbsdb > 0,
		hasPictures: property.nb_pictures > 0,
	};
};

window.themeSetPoint = (property, addressExacte) => {
	if (addressExacte) {
		return {
			fillColor: "#547aab",
			fillOpacity: 1,
			weight: 10,
			color: "transparent",
			radius: circleSizeKm * (muGlobalData.wpIsMobile === "1" ? 20 : 10),
		};
	} else {
		return {
			fillColor: "#547aab",
			fillOpacity: 0.75,
			stroke: false,
			radius: circleSizeKm * 500,
		};
	}
};

function formatSlugForDisplay(value = "") {
	return value
		.toString()
		.replace(/[_-]+/g, " ")
		.replace(/\s+/g, " ")
		.trim()
		.replace(/\b\w/g, (letter) => letter.toUpperCase());
}

function setLocalityFromAddressComponents(addressComponents, placeGeometry) {
	let canton = "";
	let sector = "";

	$.each(addressComponents, (i, gSector) => {
		let name = procab_replaceSpecialChars(gSector.long_name).toLowerCase();
		if (gSector.types.includes("administrative_area_level_1")) {
			canton = name;
		} else if (gSector.types.includes("locality")) {
			sector = name;
		}
	});

	if (placeGeometry && placeGeometry.location) {
		$("input[name='rem_property_lat']").val(placeGeometry.location.lat());
		$("input[name='rem_property_lng']").val(placeGeometry.location.lng());
	}

	if (canton.length > 0) {
		$("input[name='rem_property_canton']").val(canton);
		$("input[name='rem_property_type_locality_google']").val("administrative_area_level_1");
	}
	if (sector.length > 0 && sector !== canton) {
		$("input[name='rem_property_sector']").val(sector);
		$("input[name='rem_property_locality']").val(sector);
		$("input[name='rem_property_type_locality_google']").val("locality");
	} else {
		$("input[name='rem_property_locality']").val("");
		$("input[name='rem_property_sector']").val("");
	}
}

function hydrateLocalityInputFromUrl() {
	let $localityInput = $("#input-search-localite");
	let citySlug = $("input[name='rem_property_sector']").val();
	let cantonSlug = $("input[name='rem_property_canton']").val();

	if (!citySlug && !cantonSlug) {
		return;
	}

	if (citySlug) {
		$localityInput.val(formatSlugForDisplay(citySlug));
	} else if (cantonSlug) {
		$localityInput.val(formatSlugForDisplay(cantonSlug));
	}
	$("#input-search-localite-clear").removeClass("d-none").addClass("d-flex");

	if ($("input[name='rem_property_lat']").val() && $("input[name='rem_property_lng']").val()) {
		return;
	}

	let geocoder = new google.maps.Geocoder();
	let address = [formatSlugForDisplay(citySlug), formatSlugForDisplay(cantonSlug), "Suisse"].filter((item) => item.length > 0).join(", ");

	geocoder.geocode(
		{
			address: address,
			componentRestrictions: { country: "CH" },
		},
		(results, status) => {
			if (status !== "OK" || !results || results.length === 0) {
				return;
			}

			let result = results[0];
			setLocalityFromAddressComponents(result.address_components || [], result.geometry);

			if (result.address_components) {
				let localityComponent = result.address_components.find((component) => component.types.includes("locality"));
				if (localityComponent && localityComponent.long_name) {
					$localityInput.val(localityComponent.long_name);
				}
			}

			propertySearch.ajaxPropertiesSearch(themeCreateListOfProperties);
		},
	);
}

$(document).ready(() => {
	new TomSelect("#input-search-type", {
		allowEmptyOption: true,
	}).on("focus", () => {
		google.maps.event.trigger(document.getElementById("input-search-localite"), "blur");
		$("#input-search-localite, #input-search-budget").blur();
	});
	new TomSelect("#input-search-pieces", {
		allowEmptyOption: true,
		render: {
			item: function (data, escape) {
				return $.isNumeric(data.text) ? "<div>" + escape(data.text) + " pièce" + (escape(data.text) > 1 ? "s" : "") + " min" + "</div>" : "<div>" + escape(data.text) + "</div>";
			},
		},
	}).on("focus", () => {
		google.maps.event.trigger(document.getElementById("input-search-localite"), "blur");
		$("#input-search-localite, #input-search-budget").blur();
	});

	// filter on results
	new TomSelect("#select_properties", {
		allowEmptyOption: true,
	}).on("focus", () => {
		google.maps.event.trigger(document.getElementById("input-search-localite"), "blur");
		$("#input-search-localite, #input-search-budget").blur();
	});
	$("#select_properties").on("change", function () {
		let _val = $(this).val().split(" ");
		let _wrapper = $(".archive-filter");
		_wrapper.find('input[name="rem_sort"]').val(_val[0]);
		_wrapper.find('input[name="rem_order"]').val(_val[1]);
		$("#input-search-type").trigger("change");
	});

	$("#archive-property-map-container").on("click", ".js-property-infowindow-close", (e) => {
		e.preventDefault();
		e.stopPropagation();
		closePropertyInfowindow();
	});

	propertySearch = new PropertySearch("full", themeCreateListOfProperties, "", $(".archive-filter"));
	window.initMap();

	// Le callback Google peut construire la carte avant le chargement de ce bundle,
	// auquel cas le hook theme_customize_gmap_constructor du plugin n'existe pas encore.
	if (propertyMap?.googleMap) {
		propertyMap.googleMap.setOptions({
			zoomControl: true,
			zoomControlOptions: {
				position: google.maps.ControlPosition.RIGHT_BOTTOM,
			},
		});

		// Les lots d'une même promotion partagent le point de la commune. Le spiderfier
		// les éventaille au clic, sinon ils restent empilés au pixel près.
		installSpiderfier();

		installClusterRenderer();
	}

	// sticky map top position (header calculation)
	$(window).trigger("scroll");
	$(window).on("resize scroll", () => mapTopPosition());

	let _originalSize = $(window).width() + $(window).height();
	$(window).resize(function () {
		if ($(window).width() + $(window).height() != _originalSize) {
			$(".archive-filter.is-visible").css({
				paddingTop: "15%",
				justifyContent: "unset",
			});
		} else {
			$(".archive-filter.is-visible").removeAttr("style");
		}
	});
});

function mapTopPosition() {
	let navbarHeight = $("header .header__inner").outerHeight();
	let archiveFilterHeight = $(".archive-filter").outerHeight();
	if ($(window).outerWidth() < 1201) {
		$("#archive-property-map-container").removeClass("top-0").css({ top: "" });
	} else {
		let archiveResults = $(".archive-results").outerHeight();

		// set dynamic map position after form div as been passed
		if ($(window).scrollTop() > archiveFilterHeight && $(window).scrollTop() < archiveFilterHeight + navbarHeight) {
			$("#archive-property-map-container")
				.removeClass("top-0")
				.css({ top: $(window).scrollTop() - archiveFilterHeight });
		}

		// set static map position equal to navbar size position after form div and nav bar as been passed
		else if ($(window).scrollTop() >= archiveFilterHeight + navbarHeight && $(window).scrollTop() + $(window).outerHeight() < archiveResults + navbarHeight + archiveFilterHeight) {
			$("#archive-property-map-container").removeClass("top-0").css({ top: navbarHeight });
		}

		// set dynamic map position after archive results div as been passed
		else if ($(window).scrollTop() + $(window).outerHeight() >= archiveResults + navbarHeight + archiveFilterHeight && $(window).scrollTop() + $(window).outerHeight() < archiveResults + navbarHeight * 2 + archiveFilterHeight) {
			$("#archive-property-map-container")
				.removeClass("top-0")
				.css({ top: navbarHeight - ($(window).scrollTop() + $(window).outerHeight() - (archiveResults + navbarHeight + archiveFilterHeight)) });
		}

		// remove top position if form div as not been passed
		else {
			$("#archive-property-map-container").addClass("top-0").css({ top: "" });
		}
	}
}

function themeCreateListOfProperties(response, filter) {
	if (response.properties.length === 0) {
		$("#property-list .archive-results__no-properties").removeClass("d-none");
		$("#property-list .properties_results_text").addClass("d-none");
	} else {
		$("#property-list .archive-results__no-properties").addClass("d-none");
		$("#property-list .properties_results_text").removeClass("d-none");
	}

	// display the properties count
	let plural = response.properties.length > 1 ? "s" : "";
	$("#properties-count").text(response.properties.length + " bien" + plural + " trouvé" + plural);
	$("#properties-count").removeClass("d-none");

	response.properties = response.properties.reverse();

	$("#properties_number").text(response.properties.length);

	// Le rafraîchissement des marqueurs vit dans remAfterSearch, que ce callback remplace.
	syncMapMarkers(response.properties);

	propertySearch.createListOfProperties(propertySearch.properties);

	// allow to set the right map top on desktop after the properties are loaded
	mapTopPosition();

	// go to the top of the page after a search on mobile
	if (muGlobalData.wpIsMobile === "1" && propertySearch.properties.length === 0) {
		procab_smooth_anchor("#property-list", { position: -200, speed: 0 });
	}
}

let propertySearchLoader = $("#loader-property-search");
global.theme_action_before_search = (filters) => {
	propertySearchLoader.css("z-index", 100).css("opacity", 1).show().fadeTo(0.5, 1);
};

global.theme_action_after_search = (properties) => {
	const container = document.getElementById("property-list-verbatims");

	if (container) {
		const children = Array.from(container.children).reverse();

		container.innerHTML = "";
		children.forEach((child) => container.appendChild(child));
	}

	setTimeout(() => propertySearchLoader.fadeTo(0.5, 0), 250);
	setTimeout(() => propertySearchLoader.css("z-index", -1).hide(), 750);
};

// gmaps select
google.maps.event.addDomListener(window, "load", function () {
	let places = new google.maps.places.Autocomplete(document.getElementById("input-search-localite"), {
		componentRestrictions: { country: "CH" },
	});
	google.maps.event.addListener(places, "place_changed", function () {
		let place = places.getPlace();
		sectorGSearch = place.address_components;
		if (typeof place.address_components === "undefined") {
			return;
		}
		setLocalityFromAddressComponents(place.address_components, place.geometry);
		propertySearch.ajaxPropertiesSearch(themeCreateListOfProperties);
	});

	hydrateLocalityInputFromUrl();

	// check if the 'input-search-localite' select is empty (then remove lat/lng & canton/sector data fields)
	$("#input-search-localite").on("change", (e) => {
		if ($(e.currentTarget).val().length === 0) {
			clearLocalityInput();
		} else {
			$("#input-search-localite-clear").removeClass("d-none").addClass("d-flex");
		}
	});

	// clear locality search input
	$("#input-search-localite-clear").on("click", (e) => {
		// remove the close button
		$(e.currentTarget).toggleClass("d-flex d-none");

		// clear previous locality data
		clearLocalityInput();
		$("#input-search-localite").val("");

		// launch a search
		propertySearch.ajaxPropertiesSearch(themeCreateListOfProperties);
	});

	$(window).on("resize", () => {
		setTimeout(() => $(".pac-container").css("top", $("#input-search-localite").offset().top + $("#input-search-localite").outerHeight()));
		setTimeout(() => $(".pac-container").css("top", $("#input-search-localite").offset().top + $("#input-search-localite").outerHeight()), 100);
		setTimeout(() => $(".pac-container").css("top", $("#input-search-localite").offset().top + $("#input-search-localite").outerHeight()), 250);
		setTimeout(() => $(".pac-container").css("top", $("#input-search-localite").offset().top + $("#input-search-localite").outerHeight()), 500);
	});
});

function clearLocalityInput() {
	sectorGSearch = [];
	mapPropertiesId = [];

	$("input[name='rem_property_lat']").val("");
	$("input[name='rem_property_lng']").val("");
	$("input[name='rem_property_canton']").val("");
	$("input[name='rem_property_sector']").val("");
	$("input[name='rem_property_locality']").val("");
	$("input[name='rem_sectors_terms_selected']").val("");
	$("input[name='rem_property_sector_gsearch']").val("");

	propertySearch.filter = propertySearch.getFormFieldsData();
	let url = propertySearch.seoUpdateURL();
	if (!!url) {
		window.history.pushState({ path: url }, "", url);
	}
}
